var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{class:_vm.$style.bar},[_c('li',{style:({ backgroundColor: _vm.color })}),_c('li',{class:( _obj = {}, _obj[_vm.$style.nocolor] = _vm.tier < 2, _obj ),style:({ backgroundColor: _vm.color })}),_c('li',{class:( _obj$1 = {}, _obj$1[_vm.$style.nocolor] = _vm.tier < 3, _obj$1 ),style:({ backgroundColor: _vm.color })})])
var _obj;
var _obj$1;}
var staticRenderFns = []

export { render, staticRenderFns }